import uiSimulationFinancialAnalysis from './financial-analysis'
import uiSimulationCaptureAnalysis from './capture-financial-analysis'
export { uiSimulationFinancialAnalysis, uiSimulationCaptureAnalysis }